import React from 'react';
import { Link } from 'react-router-dom';

// The markup half of a door CTA (#384, extracted for #387/#388).
//
// One element with two shapes, and the shape is the point: a signed-in visitor
// gets a real <Link> into /studio carrying ?door=, so the studio can attribute
// them on mount and a middle-click/copy-link still works. A signed-out visitor
// gets a <button>, because there is nothing to navigate to yet — the CTA opens
// the app-level sign-in modal and the page stays put until the popup resolves.
//
// Rendering an <a href="/studio"> for a signed-out visitor would be the bug
// this shape prevents: it would bounce them off the door before they had an
// account, and lose the attribution the door just earned.
//
// Both shapes carry `.door-primary-cta`, whose rules in DoorPage.css pin every
// property a UA sets differently on a <button> vs an <a> so the two are pixel
// identical.
function DoorCta({ ctaId, testId, signedIn, studioHref, onActivate, children }) {
  const handleClick = () => onActivate(ctaId);

  if (signedIn) {
    return (
      <Link
        to={studioHref}
        className="door-primary-cta"
        data-testid={testId}
        onClick={handleClick}
      >
        {children}
      </Link>
    );
  }

  return (
    <button
      type="button"
      className="door-primary-cta"
      data-testid={testId}
      onClick={handleClick}
    >
      {children}
    </button>
  );
}

export default DoorCta;
